import React from 'react';

const SvgGh = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="GH_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="GH_svg__b" fill="#fff">
        <use xlinkHref="#GH_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#GH_svg__a" />
      <path fill="#E71F37" mask="url(#GH_svg__b)" d="M0 0h28v6.667H0z" />
      <path fill="#118B56" mask="url(#GH_svg__b)" d="M0 13.333h28V20H0z" />
      <path fill="#FDD64C" mask="url(#GH_svg__b)" d="M0 6.667h28v6.667H0z" />
      <path
        fill="#262626"
        mask="url(#GH_svg__b)"
        d="M14 11.612l-1.96 1.418.744-2.302-1.954-1.425 2.419-.004L14 7l.751 2.3 2.42.003-1.955 1.425.743 2.302z"
      />
    </g>
  </svg>
);

export default SvgGh;
